export const SHORT_LINK_REQUESTED = 'SHORT_LINK_REQUESTED';
export const SHORT_LINK_SUCCEEDED = 'SHORT_LINK_SUCCEEDED';
export const SHORT_LINK_FAILED = 'SHORT_LINK_FAILED';

export const requestShortLinkData = (shortCode) => ({
    type: SHORT_LINK_REQUESTED,
    payload: {
        shortCode,
    },
});

export const shortLinkSucceeded = (data) => ({
    type: SHORT_LINK_SUCCEEDED,
    payload: data,
});

export const shortLinkFailed = (errors) => ({
    type: SHORT_LINK_FAILED,
    payload: {
        errors,
    },
});
